module.exports = __webpack_public_path__ + "static/media/event-header.ec8026bb.svg";